import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IPage, IPageSize, ISearchValue, ISort, TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	siteId: string;
	vendor: string | null;
	siteType: string | null;
	technology: string | null;
	installedOnAsset: boolean | null;
}

const initialState: IInitialState = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: null,
	siteId: '',
	vendor: null,
	siteType: null,
	technology: null,
	installedOnAsset: null,
	searchValue: '',
};

const sites = createSlice({
	name: 'sites',
	initialState,
	reducers: {
		setPage: (state, action: PayloadAction<IPage>) => {
			state.page = action.payload.page;
		},
		setPageSize: (state, action: PayloadAction<IPageSize>) => {
			state.pageSize = action.payload.pageSize;
			state.page = initialState.page;
		},
		setSort: (state, action: PayloadAction<ISort>) => {
			state.sortDirection = action.payload.sortDirection;
			state.sortFieldName = action.payload.sortFieldName;
		},
		setSiteId: (state, action: PayloadAction<{ siteId: string }>) => {
			state.siteId = action.payload.siteId;
			state.page = initialState.page;
		},
		setVendor: (state, action: PayloadAction<{ vendor: string | null }>) => {
			state.vendor = action.payload.vendor;
			state.page = initialState.page;
		},
		setSiteType: (state, action: PayloadAction<{ siteType: string | null }>) => {
			state.siteType = action.payload.siteType;
			state.page = initialState.page;
		},
		setSearchValue: (state, action: PayloadAction<ISearchValue>) => {
			state.searchValue = action.payload.searchValue;
			state.page = initialState.page;
		},
		setTechnology: (state, action: PayloadAction<{ technology: string | null }>) => {
			state.technology = action.payload.technology;
			state.page = initialState.page;
		},
		setInstalledOnAsset: (state, action: PayloadAction<{ installedOnAsset: boolean | null }>) => {
			state.installedOnAsset = action.payload.installedOnAsset;
			state.page = initialState.page;
		},
		resetManageSitesDBTable: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setSiteId,
	resetManageSitesDBTable,
	setVendor,
	setSiteType,
	setSearchValue,
	setTechnology,
	setInstalledOnAsset,
} = sites.actions;

export default sites.reducer;
